import {
  FloatingFormItem,
  InputDecimal,
  InputText,
} from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Row } from 'antd';

const NoteItensValues = () => {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem
          label="Valor total bruto"
          name="grossServiceValue"
          rules={[defaultEmptyFieldError]}
        >
          <InputDecimal />
        </FloatingFormItem>
      </Col>

      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem label="Base cálculo" name="taxBase">
          <InputText onlyNumber />
        </FloatingFormItem>
      </Col>

      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem label="Deduções" name="deductions">
          <InputDecimal />
        </FloatingFormItem>
      </Col>
    </Row>
  );
};

export default NoteItensValues;
